// frontend/src/components/layout/UserChip.jsx
//
// The signed-in user's identity chip: their photo, or their initials on their
// colour when they have none or it fails to load.

import { useState } from 'react';
import { avatarColor, initials, userAvatarSeed, userDisplayName } from '../../utils/avatar';
import '../../styles/avatar-chip.css';

export default function UserChip({ user }) {
  const [photoFailed, setPhotoFailed] = useState(false);
  const showPhoto = Boolean(user.avatar) && !photoFailed;
  return (
    <span className="avatar-chip" style={showPhoto ? undefined : { background: avatarColor(userAvatarSeed(user)) }}>
      {showPhoto
        ? <img src={user.avatar} alt="" onError={() => setPhotoFailed(true)} />
        : initials(userDisplayName(user))}
    </span>
  );
}
